var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowRightLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m16.568 6.86-.917.876 2.8 2.92h-14.3v1.276h14.276l-2.776 2.9.917.877 4.25-4.425-4.25-4.425Z",
  fill: "#DF3637"
})));
export default SvgArrowRightLarge;